module.exports = __webpack_public_path__ + "static/the-obstacle-is-the-way-86c588ca5f33b75319fa37a66342da5d.webp";